// Messages here are written for WhatsApp as often as for the web: flows use *bold* / _italic_ /
// ~strike~, agents type Markdown (**bold**, [label](url)). Markdown-it would read *x* as italic,
// so this small formatter covers both dialects. Input is escaped first, so the output is safe for v-html.

const escapeHtml = text =>
  text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

const anchor = (href, label) =>
  `<a href="${href}" target="_blank" rel="noopener noreferrer" class="underline underline-offset-2 decoration-1 break-words">${label}</a>`;

// Bare domains ("nikolasferreira.com.br/dashboard-emendas", "t.me/foo") are how flows usually write links.
const BARE_DOMAIN =
  /(^|[\s(])((?:[a-z0-9-]+\.)+(?:com\.br|org\.br|gov\.br|net\.br|com|org|net|io|ai|app|me|br|co|dev|info)(?:\/[^\s<)]*)?)/gi;
const URL_PATTERN = /(^|[\s(])(https?:\/\/[^\s<)]+)/gi;
const MD_LINK = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g;
const TRAILING_PUNCTUATION = /[.,;:!?]+$/;

// Links are pulled out into placeholders before emphasis runs, so `_` inside a URL never becomes italics.
const extractLinks = (html, stash) => {
  const withLink = (lead, url, schemeless) => {
    const trailing = url.match(TRAILING_PUNCTUATION)?.[0] || '';
    const clean = trailing ? url.slice(0, -trailing.length) : url;
    return `${lead}${stash(anchor(schemeless ? `https://${clean}` : clean, clean))}${trailing}`;
  };

  return html
    .replace(MD_LINK, (_, label, url) => stash(anchor(url, label)))
    .replace(URL_PATTERN, (_, lead, url) => withLink(lead, url, false))
    .replace(BARE_DOMAIN, (_, lead, url) => withLink(lead, url, true));
};

const emphasize = html =>
  html
    .replace(/\*\*([^*\n]+)\*\*/g, '<strong>$1</strong>')
    .replace(
      /(^|[\s(>])\*([^*\n]+)\*(?=$|[\s).,!?:;<])/g,
      '$1<strong>$2</strong>'
    )
    .replace(/(^|[\s(>])_([^_\n]+)_(?=$|[\s).,!?:;<])/g, '$1<em>$2</em>')
    .replace(/(^|[\s(>])~([^~\n]+)~(?=$|[\s).,!?:;<])/g, '$1<s>$2</s>')
    .replace(
      /`([^`\n]+)`/g,
      '<code class="rounded px-1 bg-ink/10 text-[0.92em]">$1</code>'
    );

export const formatMessage = text => {
  if (!text) return '';
  const tokens = [];
  const stash = markup => {
    tokens.push(markup);
    return `\uE000${tokens.length - 1}\uE000`;
  };
  const html = emphasize(extractLinks(escapeHtml(String(text).trim()), stash));
  return html
    .replace(/\uE000(\d+)\uE000/g, (_, index) => tokens[Number(index)])
    .replace(/\n/g, '<br>');
};
